import Card from '../Components/Card';
import Carousel from '../Components/Carousel';
import InputSearch from '../Components/InputSearch';
import Container from '../Layouts/Container';
import Header from '../Layouts/Header';
import { useAtom, useSetAtom } from 'jotai';
import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState, useRef, useContext } from 'react';
import { resetTemporaryAtom, setTemporaryInitDashboardAtom } from '../Services/store/atoms';
import Modal from '../Components/Modal';
import { setAuthUserAtom, setDataUserAtom, isAuthAtom, dataUserAtom, authUserAtom } from '../Services/store/atoms';
import { resolveResumeActionPath } from '../Services/resumeAction';
import { LuMail, LuLock } from 'react-icons/lu';
import { IconContext } from "react-icons";
import config from '../Config';
import axios from 'axios';
import ImageSlider from '../Components/ImageSlider';

import { FaSpinner } from 'react-icons/fa';
import DarkModeContext from '../Components/DarkModeContext';
import ModalActions from '../Components/ModalActions';
import LayoutHomeUser from '../Layouts/Admin/Layout';
import GoogleLoginButton from '../Components/GoogleLoginButton';

function Login() {
    const history = useHistory();
    const location = useLocation();
    // Destino opcional tras el login (deep-link desde correos/campañas).
    // Solo se aceptan rutas internas ("/algo") para evitar redirecciones
    // abiertas hacia sitios externos.
    const getSafeRedirect = () => {
        const r = new URLSearchParams(location.search).get('redirect');
        if (r && r.startsWith('/') && !r.startsWith('//')) return r;
        return null;
    };
    // Si se llegó acá desde la pantalla de "Apaga tu VPN" (ver AccessGate), el
    // único propósito de este login es pasar ese bloqueo — no tiene sentido
    // mostrar el menú lateral entero para eso, solo el header con el logo.
    const fromVpnBlock = new URLSearchParams(location.search).get('from') === 'vpnBlock';
    const setTemporaryInitDashboard = useSetAtom(setTemporaryInitDashboardAtom);
    const setAuthUser = useSetAtom(setAuthUserAtom);
    const setDataUser = useSetAtom(setDataUserAtom);
    const modalRef = useRef(null);
    const [email, setEmail] = useState(null);
    const [emailV, setEmailV] = useState(false);
    const [password, setPassword] = useState(null);
    const [passwordV, setPasswordV] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // Estado para el spinner
    const [showResetForm, setShowResetForm] = useState(false); // Estado para mostrar el formulario de restablecimiento de contraseña
    const [resetEmail, setResetEmail] = useState(''); // Estado para el correo electrónico de restablecimiento
    const [isAuth] = useAtom(isAuthAtom);
    const [dataUser] = useAtom(dataUserAtom);
    const [authUser] = useAtom(authUserAtom);
    // Acción a retomar tras loguearse (ej. abrir el chat con la modelo que se
    // quería contactar) — la pusimos ahí nosotros mismos vía history.push
    // state (ver AuthRequiredModal), no llega de afuera.
    const resumeAction = location.state?.resumeAction || null;
    const { darkMode } = useContext(DarkModeContext); // Consume the DarkModeContext

    const navigate = (route) => {
        setTemporaryInitDashboard(true);
        history.push(route);
    };

    useEffect(() => {
        console.log(email);
        setEmailV(false);
    }, [email]);

    useEffect(() => {
        console.log(password);
        setPasswordV(false);
    }, [password]);

    useEffect(() => {
        if (isAuth) {
            if (resumeAction) {
                resolveResumeActionPath(resumeAction, authUser?.token, dataUser.role).then((path) => {
                    if (path) history.replace(path);
                    // si falla, sigue en /login sin romper nada — el usuario ya está
                    // autenticado y puede navegar manualmente
                });
                return;
            }
            const redirectTo = getSafeRedirect();
            if (redirectTo) {
                history.push(redirectTo);
                return;
            }
            if (!dataUser.role) {
                history.push('/choose-role');
            } else if (dataUser.role === 'client') {
                history.push('/client');
            } else if (dataUser.role === 'model') {
                if (!dataUser.name || !dataUser.phone) {
                    history.push('/model/complete-registration');
                } else {
                    history.push('/model');
                }
            } else if (dataUser.role === 'admin' || dataUser.role === 'assistant') {
                history.push('/admin');
            } else {
                history.push('/' + dataUser.role);
            }
        }
    }, [isAuth, dataUser, history, resumeAction, authUser]);

    const login = () => {
        let message = "";

        if (!email) {
            setEmailV(true);
            message += "Ingrese Email -";
        }

        if (!password) {
            setPasswordV(true);
            message += " Ingrese Contraseña.";
        }

        if (message !== "") {
            modalRef.current.openModal(
                'error', 'Campos faltantes!',
                <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-500'}`}>
                    {message}
                </p>,
                <ModalActions onClose={() => modalRef.current.closeModal()} />
            );
            return;
        }
        setIsLoading(true);
        axios.post(`${config.REACT_APP_BASE_URL}/api/dasboard/v1/auth/login`,
            {
                email: email,
                password: password
                // Sin device_name: el backend arma el nombre ("Chrome en Windows")
                // desde el navegador para la lista de sesiones activas.
            },
            {
                headers: {
                    'Content-Type': "application/json",
                    'Accept': "application/json",
                }
            }
        )
            .then(function (response) {
                axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`;
                axios.get(`${config.REACT_APP_BASE_URL}/api/v1/auth/data`)
                    .then(function (data) {
                        // setAuthUser recién acá, junto con setDataUser: si isAuth pasara a
                        // true antes de tener el perfil fresco, el useEffect de más arriba
                        // (que también reacciona a isAuth) navegaría con el dataUser viejo
                        // todavía en localStorage — por eso aparecía de golpe la pantalla de
                        // completar perfil aunque el usuario ya la hubiera llenado antes.
                        setDataUser(data.data);
                        setAuthUser(response.data);
                        // Si hay resumeAction, no redirigimos acá: el useEffect de más
                        // arriba (que reacciona a isAuth) ya se encarga, y hacerlo también
                        // acá duplicaría el llamado async a resolveResumeActionPath —dos
                        // POST a chat/start corriendo en paralelo compitiendo por quién
                        // pisa la URL final, con resultado inconsistente según cuál
                        // resolviera último.
                        if (resumeAction) {
                            setIsLoading(false);
                            return;
                        }
                        const redirectTo = getSafeRedirect();
                        if (redirectTo) {
                            history.push(redirectTo);
                            setIsLoading(false);
                            return;
                        }
                        if (!data.data.role) {
                            history.push('/choose-role');
                        } else if (data.data.role === 'client') {
                            history.push('/client');
                        } else if (data.data.role === 'model') {
                            if (!data.data.name || !data.data.phone) {
                                history.push('/model/complete-registration');
                            } else {
                                history.push('/model');
                            }
                        } else if (data.data.role === 'admin' || data.data.role === 'assistant') {
                            history.push('/admin');
                        } else {
                            history.push('/' + data.data.role);
                        }
                        setIsLoading(false);
                    })
                    .catch(function (error) {
                        setIsLoading(false);
                        console.error(error);
                    });
            })
            .catch(function (error) {
                setIsLoading(false);
                const errMsg = error.response?.data?.message || 'Error al iniciar sesión';
                modalRef.current.openModal(
                    'error', errMsg,
                    <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-500'}`}>
                        {errMsg}
                    </p>,
                    <ModalActions onClose={() => modalRef.current.closeModal()} />
                );
            });
    };

    // Fila con error: marca roja a la izquierda y un sacudón, como en iOS.
    const validate = (field) => {
        if (field) return "ap-row-invalid animate__animated animate__headShake";
        return "";
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            login();
        }
    };

    const handleResetPassword = () => {
        setIsLoading(true);
        axios.post(`${config.REACT_APP_BASE_URL}/api/v1/auth/reset_password_without_token`,
            {
                email: resetEmail,
            },
            {
                headers: {
                    'Content-Type': "application/json",
                    'Accept': "application/json",
                }
            }
        )
            .then(function (response) {
                modalRef.current.openModal(
                    'success', 'Restablecimiento de contraseña',
                    <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-500'}`}>
                        {response.data.message}
                    </p>,
                    <ModalActions onClose={() => {
                        modalRef.current.closeModal();
                        setShowResetForm(false);
                        setResetEmail('');
                    }} />
                );
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
                modalRef.current.openModal(
                    'error', 'Error al restablecer la contraseña',
                    <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-500'}`}>
                        {error.response.data.message}
                    </p>,
                    <ModalActions onClose={() => modalRef.current.closeModal()} />
                );
            });
    };

    return (
        <LayoutHomeUser hideSidebar={fromVpnBlock}>
            <div className="ap-screen ap-screen-inset -m-2 lg:-m-4 flex flex-col items-center justify-center min-h-[calc(100dvh-3.5rem)] px-4 py-10">
                <div className="w-full max-w-[420px]">
                    <div className="ap-card p-5 sm:p-6">
                        <h1 className="ap-title-2 mb-4">
                            {showResetForm ? 'Reset Password' : 'Sign in to your account'}
                        </h1>
                        {showResetForm ? (
                            <>
                                <div className="ap-group">
                                    <label className="ap-row">
                                        <LuMail className="ap-row-icon" />
                                        <input
                                            type="email"
                                            inputMode="email"
                                            autoComplete="email"
                                            aria-label="Email"
                                            value={resetEmail}
                                            onChange={(event) => setResetEmail(event.target.value)}
                                            onKeyDown={(event) => event.key === 'Enter' && handleResetPassword()}
                                            className="ap-input"
                                            placeholder="Your email"
                                            disabled={isLoading}
                                        />
                                    </label>
                                </div>
                                <button
                                    onClick={handleResetPassword}
                                    className="ap-btn ap-btn-filled w-full mt-5"
                                    disabled={isLoading}
                                >
                                    {isLoading ? <FaSpinner className="animate-spin" /> : 'Send Reset Link'}
                                </button>
                                <div className="text-center mt-4">
                                    <button type="button" onClick={() => setShowResetForm(false)} className="ap-link text-[13px]">
                                        Back to Login
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="ap-group">
                                    <label className={`ap-row ${validate(emailV)}`}>
                                        <LuMail className="ap-row-icon" />
                                        <input
                                            type="email"
                                            inputMode="email"
                                            autoComplete="email"
                                            aria-label="Email"
                                            value={email ?? ''}
                                            onChange={(event) => setEmail(event.target.value)}
                                            onKeyDown={handleKeyDown}
                                            className="ap-input"
                                            placeholder="Your email"
                                            disabled={isLoading}
                                        />
                                    </label>
                                    <label className={`ap-row ${validate(passwordV)}`}>
                                        <LuLock className="ap-row-icon" />
                                        <input
                                            type="password"
                                            autoComplete="current-password"
                                            aria-label="Password"
                                            value={password ?? ''}
                                            onChange={(event) => setPassword(event.target.value)}
                                            onKeyDown={handleKeyDown}
                                            className="ap-input"
                                            placeholder="Password"
                                            disabled={isLoading}
                                        />
                                    </label>
                                </div>
                                {emailV && <div className="ap-error">Valid email is required</div>}
                                {passwordV && <div className="ap-error">Password is required</div>}
                                <div className="flex justify-end mt-3">
                                    <button type="button" onClick={() => setShowResetForm(true)} className="ap-link text-[13px]">
                                        Forgot password?
                                    </button>
                                </div>
                                <button
                                    onClick={() => login()}
                                    className="ap-btn ap-btn-filled w-full mt-5"
                                    disabled={isLoading}
                                >
                                    {isLoading ? <FaSpinner className="animate-spin" /> : 'Sign In'}
                                </button>
                                <div className="ap-divider my-5">Or continue with</div>
                                <GoogleLoginButton darkMode={darkMode} isLoading={isLoading} setIsLoading={setIsLoading} />
                            </>
                        )}
                    </div>

                    {!showResetForm && (
                        <p className="ap-subhead text-center mt-6">
                            Don't have an account yet?{' '}
                            <button type="button" onClick={() => navigate('/register')} className="ap-link">Sign up</button>
                        </p>
                    )}
                </div>
            </div>
            <Modal ref={modalRef} />
        </LayoutHomeUser>
    );
}

export default Login;
